import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SelectSponsorsRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SelectSponsorsResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const selectSponsors = (request: SelectSponsorsRequest, options?: CashRequestOptions) =>
  post<SelectSponsorsRequest, SelectSponsorsResponse>('/2.0/cash/select-sponsors', request, {
    ...options,
    rejectOnError: true,
  })
